import {SureFlowUnitData} from './sure-flow-unit-data';

export class WorkingSureFlowUnit {

  id!: number;
  loopId!: number;
  unitData!: SureFlowUnitData;
  sequence!: number;

}
